import { createFileRoute } from '@tanstack/react-router'

import { InsightsConsolePage } from '#/modules/insights/insights-console-page'
import { validateInsightsSearch } from '#/modules/insights/model/search'

export const Route = createFileRoute('/_shell/insights')({
  component: InsightsConsolePage,
  // The tab comes from the product's own validator; the console adds the tenant.
  validateSearch: (raw: Record<string, unknown>) => ({
    ...validateInsightsSearch(raw),
    organizationId: typeof raw['organizationId'] === 'string' ? raw['organizationId'] : undefined,
  }),
})
